import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../../axios";
import { Helmet } from "react-helmet";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styles from "./Update.module.css";

import FormikControl from "../../../components/FormikControl/FormikControl";
import Button from "../../../components/Button/Button";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";

import CheckIcon from "../../../assets/images/check-icon.svg";

class Update extends Component {
  state = {
    data: null,
    isLoading: false,
  };

  componentDidMount() {
    this.fetchInvoice();
  }

  fetchInvoice = () => {
    const { id } = this.props.match.params;

    axios
      .get(`/invoices/${id}`)
      .then((response) => {
        this.setState({
          data: {
            ...response.data,
          },
        });
      })
      .catch((error) => {
        if (error.response.data.code === 2001) {
          const errors = error.response.data.errors;
          toast.error(Object.values(errors[0])[0]);
        } else {
          toast.error(error.response.data.message);
        }
      });
  };

  render() {
    const { data } = this.state;
    console.log("data", data);

    const initialValues = {
      invoice: "",
    };

    const validationSchema = Yup.object({
      invoice: Yup.mixed().required("Invoice is required"),
    });

    const onSubmit = (values) => {
      this.setState({ isLoading: true });

      const formData = new FormData();
      formData.append("invoice", values.invoice);

      axios
        .put(`/invoices/${data.id}`, formData)
        .then((response) => {
          toast.success(response.data.message);
          this.setState((prevState) => ({
            formId: prevState.formId + 1,
          }));
          this.fetchInvoice();
        })
        .catch((error) => {
          if (error.response.data.code === 2001) {
            const errors = error.response.data.errors;
            toast.error(Object.values(errors[0])[0]);
          } else {
            toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    };

    const markAsPaid = () => {
      axios
        .put(`/invoices/${data.id}/paid`)
        .then((response) => {
          toast.success(response.data.message);
          this.fetchInvoice();
        })
        .catch((error) => {
          if (error.response.data.code === 2001) {
            const errors = error.response.data.errors;
            toast.error(Object.values(errors[0])[0]);
          } else {
            toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    };

    return (
      <div className={styles.Create}>
        <Helmet>
          <title>Edit | Invoices | Lara Capital</title>
        </Helmet>
        <div className="PageHeader">
          <div className="ContentLeft">
            <div className="Title">
              <h1>Invoices</h1>
            </div>
            <Breadcrumb>
              <li>
                <Link to="/">Dashboard</Link>
              </li>
              <li>
                <Link to="/statement-requests">Invoices</Link>
              </li>
              <li>Edit</li>
            </Breadcrumb>
          </div>
          <div className="ContentRight">
            {data && data.status.id === 0 ? (
              <Button btnType="Success" clicked={() => markAsPaid()}>
                <span>Mark as Paid</span>
              </Button>
            ) : (
              <div className={styles.Paid}>
                <img src={CheckIcon} alt="Paid" />
                <span>Paid</span>
              </div>
            )}
          </div>
        </div>
        <div className="PageContent DataForm">
          <div className="ContentHeader">
            <div className="Title">
              <h1>Edit Invoice</h1>
            </div>
          </div>
          <div className="MainContent">
            <div className="FormContainer">
              {data ? (
                <Formik
                  key={this.state.formId}
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {({ setFieldValue }) => {
                    return (
                      <Form>
                        <div
                          className={["FormBody", styles.FormBody].join(" ")}
                        >
                          <FormikControl
                            control="fileInput"
                            label="Invoice *"
                            name="invoice"
                            accept=".pdf"
                            setFieldValue={setFieldValue}
                            fileFormats="PDF"
                            maxFileSize="10MB"
                            value=""
                          />
                        </div>

                        <div
                          className={["FormActions", styles.FormActions].join(
                            " "
                          )}
                        >
                          <Button
                            btnType="Primary"
                            type="Submit"
                            width="W100"
                            isLoading={this.state.isLoading}
                          >
                            Re-Send
                          </Button>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              ) : null}
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
}

export default Update;
